import { gql } from '@apollo/client';

export const GET_CHECKGRADES_FILTER = gql`
  query SkWeb_CheckGradeFilter($tempPrincipalId: ID) {
    teachers(tempPrincipalId: $tempPrincipalId) {
      id
      name
      username
    }
    classrooms {
      id
      name
    }
  }
`;
